import { render, staticRenderFns } from "./DetalheUploadEmail.vue?vue&type=template&id=e15be9b4&scoped=true"
import script from "./DetalheUploadEmail.vue?vue&type=script&lang=js"
export * from "./DetalheUploadEmail.vue?vue&type=script&lang=js"
import style0 from "./DetalheUploadEmail.vue?vue&type=style&index=0&id=e15be9b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e15be9b4",
  null
  
)

export default component.exports